import React from "react";
import { Placeholder } from "@bloomberg/media-ui-article";
import styles from "./styles.module.css";

export const MarketSummariesPlaceholder = () => {
  return (
    <section className={styles.marketSummaries}>
      <div className={styles.sectionTitle}>Market Summaries</div>
      <div className={styles.container}>
        <div className={styles.headerContainer}>
          <Placeholder.Image className={styles.headerImage} />
          <div className={styles.headerTitle}>
            <Placeholder.Line />
            <Placeholder.Line />
          </div>
        </div>
        <div>
          <Placeholder.Line />
          <Placeholder.Line />
          <Placeholder.Line />
          <Placeholder.Line />
          <Placeholder.Line />
        </div>
      </div>
    </section>
  );
};
